import { useState } from "react";
import { FaArrowUpRightFromSquare, FaGithub } from "react-icons/fa6";
import { motion } from "framer-motion";

export default function Projects() {
  const [hovered, setHovered] = useState(null);

  const projects = [
    {
      title: "HaatOnline",
      description:
        "A scalable MERN-based grocery e-commerce platform with secure authentication, role-based dashboards, online ordering, payment integration, Docker deployment, and production hosting.",
      url: "https://haat-nine.vercel.app/",
      github: "https://github.com/KuxH/haatonline",
      tags: ["MERN", "Docker", "Authentication", "Admin Dashboard", "REST APIs", "Deployment", "Domain Configuration", "Responsive UI"],
      roles: ["Full-Stack Developer"],
    },
    {
      title: "Healthline Nepal",
      description:
        "Developed backend services, integrated databases, deployed production applications, and provided ongoing troubleshooting and technical support for a clinic management system.",
      url: "https://healthlinenepal.org/",
      github: "https://github.com/KuxH/HealthlineNepal",
      tags: ["Node.js", "Express", "MongoDB", "Backend Development", "Deployment", "Production Support"],
      roles: ["Full-Stack Developer"],
    },
    {
      title: "Effortless Beauty",
      description:
        "Developed responsive user interfaces, backend functionality, API integrations, booking features, database operations, testing, and optimization for a beauty booking platform.",
      url: "https://github.com/KuxH/Effortlessbeauty",
      github: "https://github.com/KuxH/Effortlessbeauty",
      tags: ["MERN", "Responsive Design", "Booking System", "API Integration", "MongoDB", "Performance Optimization"],
      roles: ["Full-Stack Developer"],
    },
  ];

  return (
    <section id="projects" className="relative overflow-hidden bg-[#050505] px-4 py-24 text-white sm:px-6 lg:px-8 lg:py-32">
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(42,182,0,0.13),_transparent_28%)]" />

      <div className="relative mx-auto max-w-7xl">
        <div className="mb-12 max-w-3xl">
          <div className="mb-4 inline-flex items-center rounded-full border border-white/10 bg-white/5 px-3 py-1 text-[11px] uppercase tracking-[0.24em] text-white/60">
            Selected Work
          </div>
          <h2 className="font-display text-3xl font-semibold sm:text-4xl lg:text-5xl">
            Projects
          </h2>
          
        </div>

        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
          {projects.map((project, index) => (
            <motion.article
              key={project.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.45, delay: index * 0.06 }}
              onHoverStart={() => setHovered(project.title)}
              onHoverEnd={() => setHovered(null)}
              className="group relative overflow-hidden rounded-[28px] border border-white/10 bg-[rgba(18,18,18,0.9)] p-5 shadow-soft backdrop-blur-md"
            >
              <div className="mb-5 h-36 overflow-hidden rounded-[20px] border border-white/10 bg-gradient-to-br from-white/10 to-white/5">
                <motion.div
                  animate={{ scale: hovered === project.title ? 1.05 : 1 }}
                  transition={{ duration: 0.3, ease: "easeOut" }}
                  className="flex h-full items-end justify-start bg-[radial-gradient(circle_at_20%_20%,rgba(42,182,0,0.24),transparent_45%)] p-5"
                >
                  <div className="rounded-full border border-accent/25 bg-accent/10 px-3 py-1 text-[11px] uppercase tracking-[0.24em] text-accent">
                    {project.roles[0]}
                  </div>
                </motion.div>
              </div>

              <div className="flex items-start justify-between gap-3">
                <div>
                  <h3 className="text-xl font-semibold text-white">{project.title}</h3>
                  <div className="mt-3 flex flex-wrap gap-2">
                    {project.roles.map((role) => (
                      <span key={role} className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-[11px] uppercase tracking-[0.2em] text-white/70">
                        {role}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              <p className="mt-4 text-sm leading-7 text-white/65">{project.description}</p>

              <div className="mt-5 flex flex-wrap gap-2">
                {project.tags.slice(0, 5).map((tag) => (
                  <span key={tag} className="rounded-full bg-white/5 px-3 py-1 text-[11px] text-white/80">
                    {tag}
                  </span>
                ))}
                {project.tags.length > 5 && (
                  <span className="rounded-full bg-white/5 px-3 py-1 text-[11px] text-white/60">
                    +{project.tags.length - 5} more
                  </span>
                )}
              </div>

              <div className="mt-6 flex items-center gap-3">
                <a
                  href={project.url}
                  target="_blank"
                  rel="noreferrer"
                  className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-2 text-sm text-white/80 transition hover:border-accent/30 hover:text-white"
                >
                  Live Demo <FaArrowUpRightFromSquare size={12} />
                </a>
                <a
                  href={project.github}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={`View ${project.title} on GitHub`}
                  className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/10 bg-white/5 text-white/80 transition hover:border-accent/30 hover:text-accent"
                >
                  <FaGithub size={16} />
                </a>
              </div>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}